import * as _ from 'lodash';

import * as moment from 'moment';
import Category from './Category';
import Wardrobe from './Wardrobe';
import Designer from './Designer';
import Status from './Status';
import Condition from './Condition';
import Style from './Style';
import Size from './Size';
import ProcessType from './ProcessType';
import ProductTrack from './ProductTrack';
import Provider from './Provider';
import User from './User';
import Media from './Media';
import Destination from './Destination';
import Location from './Location';
import Currency from './Currency';
import Color from './Color';
import ArrayList from './ArrayList';
import OrderProduct from './OrderProduct';
import Collection from './Collection';
import ProductBase from './Base/ProductBase';
import TemporaryPrice from './TemporaryPrice';
import Deliverable from './Mixin/Deliverable';
import { applyMixins } from './Mixin/Mixin';
import ProductMeta from './ProductMeta';



export enum shipping_types {
  SELF_SHIPPING = 'self',
  REFLAUNT_SHIPPING = 'reflaunt',
  FREE_SHIPPING = 'free',
}

export const SHIPPING_TYPES = [
  { value: shipping_types.FREE_SHIPPING, name: 'Free' },
  { value: shipping_types.SELF_SHIPPING, name: 'Self' },
  { value: shipping_types.REFLAUNT_SHIPPING, name: 'Reflaunt' }
];
interface ProductInterface {
  id: Number;
  sku: Number;
  name: any;
  description: String;
  size: any;
  categories: any;
  provider: any;
  condition: any;
  designer: any;
  process_type: any;
  user: any;
  styles: any;
  destination: any;
  location: any;
  currency: any;
  color: any;
  temporary_price: any;
  return_id: any;
  media: any;
}

class Product extends ProductBase implements ProductInterface {
  styles: any;
  id: Number;
  sku: Number;
  name: any;
  description: String;
  color: any;
  size: any;
  categories: any;
  provider: any;
  condition: any;
  designer: any;
  process_type: any;
  currency: any;
  user: any;
  destination: any;
  location: any;
  temporary_price: any;
  return_id: any;
  media: any;
  constructor(options) {
    super(options);
    (this as any).categories = d => {
      return new ArrayList<Category>(Category, d.data);
    };
    (this as any).designer = d => {
      return new Designer(d.data);
    };
    (this as any).process_status = d => {
      return new Status(d.data);
    };
    (this as any).process_type = d => {
      return new ProcessType(d.data);
    };
    (this as any).condition = d => {
      return new Condition(d.data);
    };
    (this as any).media = d => {
      return new ArrayList<Media>(Media, d.data);
    };
    (this as any).styles = d => {
      return new ArrayList<Style>(Style, d.data);
    };
    (this as any).size = d => {
      return new Size(d.data);
    };
    (this as any).product_track = d => {
      return new ProductTrack(d.data);
    };
    (this as any).provider = d => {
      return new Provider(d.data);
    };
    (this as any).user = d => {
      return new User(d.data);
    };
    (this as any).wardrobes = d => {
      return new ArrayList<Wardrobe>(Wardrobe, d.data);
    };
    (this as any).temporary_price = d => {
      return new ArrayList<TemporaryPrice>(TemporaryPrice, d.data);
    };
    (this as any).destination = d => {
      return new Destination(d.data);
    };
    (this as any).location = d => {
      return new Location(d.data);
    };
    (this as any).currency = d => {
      return new Currency(d.data);
    };
    (this as any).calculated_payout_currency = d => {
      return new Currency(d.data);
    };
    (this as any).fix_payout_currency = d => {
      return new Currency(d.data);
    };
    (this as any).color = d => {
      return new Color(d.data);
    };
    (this as any).order_product = d => {
      return new OrderProduct(d.data);
    };
    (this as any).checkout_product = d => {
      return new OrderProduct(d.data);
    };
    (this as any).collection = d => {
      return new Collection(d.data);
    };
    (this as any).cloned_from = d => {
      return new ProductBase(d.data);
    };
    (this as any).meta = d => {
      return new ProductMeta(d.data);
    };
    this.bind(options);
  }
  saveChanged() {
    this._backup(['destination_id', 'location_id']);
  }
  getEmail() {
    return (this as any).user ? (this as any).user.email : '';
  }
  getUserId() {
    return (this as any).user ? (this as any).user.id : '';
  }
  getTitle() {
    return this.sku;
  }
  getPathIdentifier() {
    return this.id;
  }
  getLastStatusUpdate(): moment.Moment {
    let m = moment(this['last_process_status_update']);
    return m;
  }
}
applyMixins(Product, [Deliverable]);

export default Product;
